import React from 'react';

import {type RouteData} from '../types';
import {AGENT_PATHS, ENTITY_LAUNCH_PATHS, QUEUE_PATHS} from './launchPaths';

export const LAUNCH_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'EntityLaunch',
    },
    exact: true,
    isPrivateRoute: false,
    path: ENTITY_LAUNCH_PATHS,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: true,
      routeName: 'Agent',
    },
    exact: true,
    isPrivateRoute: false,
    path: AGENT_PATHS,
    RouteComponent: React.lazy(
      () => import('../../components/Launch/LaunchContent')
    ),
  },
  {
    additionalProps: {
      allowIframes: true,
      routeName: 'Queue',
    },
    exact: true,
    isPrivateRoute: false,
    path: QUEUE_PATHS,
    RouteComponent: React.lazy(
      () => import('../../components/Launch/LaunchContent')
    ),
  },
];
